import { HttpParams } from '@angular/common/http';
import { GetDivisionsValue } from './get-divisions.value';

export class GetDivisionsValueDto {
    page: number;
    limit: number;

    constructor(data: GetDivisionsValue) {
        this.page = data.page;
        this.limit = data.limit;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit);
    }
}
